export const attachableLinkUrl = '/attachable-link';
export const feedPageUrl = '/feed';
export const storylinesPageUrl = '/storylines';
export const usagePolicyUrl = '/usage-policy';

export const userSettingsUrl = '/user-settings/general';
export const delegationSettingsUrl = '/user-settings/delegates';
export const userNotificationSettingsUrl = '/user-settings/notifications';
export const adminCenterUrl = '/admin';

export const storylineAdminSettingsUrl = '/admin/settings/storyline';

export const storylineAdminAdvancedSettingsUrl = '/admin/settings/storyline/advanced';
export const m365CopilotAdoptionPageUrl = '/admin/m365-copilot-adoption';
export const rootPageUrl = '/';
